<p class="mk-muted" *ngIf="state.loading">Loading&hellip;</p>
<p class="fx-error" role="alert" *ngIf="state.loadError">Couldn't load the categories. Close this and try again.</p>

<div class="mk-card fx" *ngFor="let card of state.cards; trackBy: trackCard" [class.done]="card.state === 'in-aivor' || card.state === 'done'">
  <b class="fx-title">{{ title(card) }}</b>
  <p class="mk-muted">{{ waiting(card) }}</p>

  <ng-container [ngSwitch]="card.state">
    <div class="fx-status ok" *ngSwitchCase="'in-aivor'"><i class="bi bi-check-lg" aria-hidden="true"></i><span>{{ card.doneText }}</span></div>
    <div class="fx-status ok" *ngSwitchCase="'done'"><i class="bi bi-check-lg" aria-hidden="true"></i><span>{{ card.doneText }}</span></div>

    <ng-container *ngSwitchCase="'choose'">
      <div class="segmented-control" role="group" [attr.aria-label]="'What to do with ' + card.name">
        <button type="button" class="segmented-option" [class.active]="card.mode === 'import'" [attr.aria-pressed]="card.mode === 'import'" (click)="state.setMode(card, 'import')">
          Bring it into Aivor
        </button>
        <button type="button" class="segmented-option" [class.active]="card.mode === 'match'" [attr.aria-pressed]="card.mode === 'match'" (click)="state.setMode(card, 'match')">
          Use an Aivor category
        </button>
      </div>

      <ng-container *ngIf="card.mode === 'import'; else match">
        <button type="button" class="btn-teal-gradient fx-use" [disabled]="card.saving || !syncEnabled" (click)="state.bringIn(card)">
          {{ card.saving ? 'Bringing it in…' : 'Bring in "' + card.name + '"' }}
        </button>
        <p class="mk-muted">Adds it to Aivor's item categories, linked to Sage.</p>
      </ng-container>
      <ng-template #match>
        <div class="field">
          <label [for]="idPrefix + 'category-' + card.sageId">Aivor category</label>
          <select [id]="idPrefix + 'category-' + card.sageId" [disabled]="card.saving" (change)="pick(card, $any($event.target).value)">
            <option value="" disabled [selected]="card.pick === null">Choose a category&hellip;</option>
            <option *ngFor="let c of state.linkable" [value]="c.categoryId" [selected]="c.categoryId === card.pick">{{ c.categoryName }}</option>
          </select>
        </div>
        <button type="button" class="btn-teal-gradient fx-use" [disabled]="card.pick === null || card.saving || !syncEnabled" (click)="state.link(card)">
          {{ card.saving ? 'Saving…' : 'Use it' }}
        </button>
      </ng-template>
      <p class="fx-error" role="alert" *ngIf="card.error">{{ card.error }}</p>
    </ng-container>

    <ng-container *ngSwitchCase="'not-in-review'">
      <p class="mk-muted">This category isn't waiting in a review, so Aivor needs to look for it in Sage.</p>
      <button type="button" class="btn-secondary fx-use" *ngIf="syncEnabled" [disabled]="state.looking" (click)="state.lookInSage()">
        {{ state.looking ? 'Looking…' : 'Look for it in Sage' }}
      </button>
    </ng-container>

    <p class="mk-muted" *ngSwitchCase="'missing'">Sage no longer has this category. Change these items' category in Sage, then try again.</p>
    <p class="mk-muted" *ngSwitchCase="'no-category'">Give them a category in Sage, then try again.</p>
  </ng-container>

  <ul class="fx-refused" *ngIf="refused(card).length">
    <li *ngFor="let item of refused(card)"><b>{{ item.name }}</b>: {{ item.reason }}</li>
  </ul>
</div>

<p class="fx-error" role="alert" *ngIf="state.applyError">{{ state.applyError }}</p>
